import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { VesselQuestionnairePopupComponent } from './vessel-questionnaire-popup.component';

@NgModule({
  declarations: [VesselQuestionnairePopupComponent],
  imports: [CommonModule, MaterialModule],
  exports: [VesselQuestionnairePopupComponent],
})
export class VesselQuestionnairePopupModule {}
